import { useEffect, useState } from 'react';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';

/**
 * Origin for "main site" links (e.g. the header logo, the order confirmation
 * "Go home" button).
 *
 * Bloom menus are reverse-proxied onto partner domains, so the configured
 * `menu_url` origin can differ from the domain the shopper is actually
 * browsing. Linking to the `menu_url` origin can therefore send shoppers to the
 * wrong site. We prefer the browser's current origin, falling back to the
 * `menu_url` origin for SSR and the initial hydration render (where `window`
 * isn't available), then switching to `window.location.origin` once mounted.
 */
export function useMainSiteUrl(): string {
  const { menuUrl } = useRootLoaderData();
  const [origin, setOrigin] = useState(() =>
    menuUrl ? new URL(menuUrl).origin : ''
  );

  useEffect(() => {
    setOrigin(window.location.origin);
  }, []);

  return origin;
}
